import React from 'react';

class ContactInformation extends React.Component{

    getLegalLink = () =>{
        return(
            <a href={"mailto: legal@ipagent.ai"} target={"_blank"} className='legal-email-link' rel={"noreferrer"}>legal@ipagent.ai</a>

        )
    }
    render() {
        return (
            <div className="terms-and-conditions-sub-section">
                <div className="sub-section-title">10.&nbsp;Contact Information</div>
                <div className="align-terms-paragraph">
                    For general inquiries, complaints, questions or claims concerning the licensed Application, please contact&nbsp;
                    {this.getLegalLink()}
                </div>
            </div>
        );
    }
}
export default ContactInformation;